import { reducerFormsActions } from './forms.reducer';
import * as selectorsImport from './forms.selectors';
import * as actionsImport from './forms.actions';

export { default } from './forms.reducer';

export const formsActions = { ...reducerFormsActions, ...actionsImport };
export const formsSelectors = selectorsImport;
